<dx-autocomplete #ac [placeholder]="placeholder" [value]="value" [searchTimeout]="searchTimeout"
    [dataSource]="autoCompleteDataSource" valueExpr="display_name" [showClearButton]="true" [readOnly]="readOnly"
    [minSearchLength]="minSearchLength" (onSelectionChanged)="onSelectionChanged($event)"
    (onValueChanged)="onValueChange($event)">
</dx-autocomplete>